import { render } from "./CommunityProfilePublic.vue?vue&type=template&id=4995a8b4&scoped=true"
import script from "./CommunityProfilePublic.vue?vue&type=script&lang=js"
export * from "./CommunityProfilePublic.vue?vue&type=script&lang=js"

import "./CommunityProfilePublic.vue?vue&type=style&index=0&id=4995a8b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4995a8b4"]])

export default __exports__